import { address } from "./address.js";
import { agent } from "./agent.js";
import { arrangement } from "./arrangement.js";
import { ask } from "./ask.js";
import { bargain } from "./bargain.js";
import { chats } from "./chats.js";
import { contacts } from "./contacts.js";
import { drivers } from "./drivers.js";
import { estimate } from "./estimate.js";
import { explain } from "./explain.js";
import { home } from "./home.js";
import { install } from "./install.js";
import { interview } from "./interview.js";
import { job } from "./job.js";
import { landing } from "./landing.js";
import { memory } from "./memory.js";
import { mentor } from "./mentor.js";
import { model } from "./model.js";
import { money } from "./money.js";
import { moving } from "./moving.js";
import { need } from "./need.js";
import { net } from "./net.js";
import { page } from "./page.js";
import { phone } from "./phone.js";
import { progress } from "./progress.js";
import { qr } from "./qr.js";
import { record } from "./record.js";
import { records } from "./records.js";
import { schedule } from "./schedule.js";
import { screens } from "./screens.js";
import { shell } from "./shell.js";
import { skill } from "./skill.js";
import { speech } from "./speech.js";
import { talk } from "./talk.js";
import { terms } from "./terms.js";
import { worker } from "./worker.js";
/** Hindi. Written by the team, to be checked by a native-speaking organiser before the pilot (docs/gigsync/i18n-review.md). */
export const hi = {
    ...job,
    ...screens,
    ...worker,
    ...model,
    ...agent,
    ...shell,
    ...money,
    ...speech,
    ...interview,
    ...home,
    ...install,
    ...net,
    ...record,
    ...records,
    ...talk,
    ...schedule,
    ...progress,
    ...need,
    ...memory,
    ...ask,
    ...landing,
    ...mentor,
    ...estimate,
    ...drivers,
    ...arrangement,
    ...skill,
    ...address,
    ...bargain,
    ...terms,
    ...explain,
    ...chats,
    ...moving,
    ...qr,
    ...page,
    ...phone,
    ...contacts,
};
//# sourceMappingURL=index.js.map